<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss"></style>
<template>
  <div style="display: flex;width: 100%;height: 473px;">
    <el-tabs tab-position="left">
      <el-tab-pane :label="$t('xianshimoban')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t('shifouxianshi') }}
          </p>
        </div>
        <div>
          <p style="margin-bottom: 8px;">{{ $t('xitongmoban') }}</p>
          <el-radio v-model="monitorSetting.MONITOR_COCKPIT_TEMPLATE" label="moren">{{ $t('moren') }}</el-radio>
        </div>
        <div style="margin-top: 20px;">
          <div style="display: flex;align-items: center;margin-bottom: 8px;">
            <p style="">{{ $t('zidingyimoban') }}</p>
            <el-popover v-model="addTemplateVisible" placement="right" width="260" trigger="click">
              <el-input size="mini" style="width: 160px;" v-model="templateName"> </el-input>
              <el-button style="margin-left: 10px;" type="primary" size="mini" @click="addTemplate">{{ $t('queding') }}</el-button>

              <el-button icon="el-icon-plus" style="margin-left: 10px;" type="primary" size="mini" slot="reference"></el-button>
            </el-popover>
          </div>

          <el-radio v-if="key != 'moren'" v-for="(key, i) in Object.keys(monitorSetting.MONITOR_COCKPIT_TEMPLATES)" v-model="monitorSetting.MONITOR_COCKPIT_TEMPLATE" :label="key">{{ key.split('||||')[1] }}</el-radio>

          <div style="margin-top: 20px;" v-if="monitorSetting.MONITOR_COCKPIT_TEMPLATE != null && monitorSetting.MONITOR_COCKPIT_TEMPLATE != 'moren'">
            <el-button style="" type="primary" size="mini" @click="toEidtTemplate">{{ $t('jinrubianjimoshi') }}</el-button>
            <el-button style="margin-left: 10px;" type="danger" size="mini" @click="removeTemplate">{{ $t('shanchu') }}</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('qitaxinxi')" style="padding: 0px 56px;">
        <div class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{ $t("kanbanbiaoti") }}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;width: 500px">
          <!--          @input="updateInput"-->
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['MONITOR_COCKPIT_HEADER_' + store.state.customer.id]"></el-input>
          <div style="margin-left: 10px">-</div>
          <el-input style="margin-left: 12px;" size="mini" v-model="monitorSetting['MONITOR_COCKPIT_CARD_TITLE_' + store.state.customer.id]"></el-input>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_cockpit_setting',
  components: {},

  data() {
    return {
      addTemplateVisible: false,
      templateName: '',
      monitorSetting: {}
    };
  },
  created() {
    this.resetData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() { },
  methods: {
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
      //每个单独初始化可以进行增量初始化，而不是一整个setting初始化
      this.monitorSetting.MONITOR_COCKPIT_TEMPLATE = this.monitorSetting.MONITOR_COCKPIT_TEMPLATE != null ? this.monitorSetting.MONITOR_COCKPIT_TEMPLATE : 'moren';
      this.monitorSetting.MONITOR_COCKPIT_TEMPLATES =
        this.monitorSetting.MONITOR_COCKPIT_TEMPLATES != null
          ? this.monitorSetting.MONITOR_COCKPIT_TEMPLATES
          : {
            moren: [
              {
                x: 0,
                y: 0,
                w: 6,
                h: 12, //应该是6
                i: 'up'
              },
              {
                x: 6,
                y: 0,
                w: 12,
                h: 12, //应该是6
                i: 'quota'
              },
              {
                x: 18,
                y: 0,
                w: 6,
                h: 12,
                i: 'produce_progress'
              },
              {
                x: 0,
                y: 12,
                w: 6,
                h: 12, //应该是6
                i: 'reason_sort'
              },
              {
                x: 6,
                y: 12,
                w: 12,
                h: 12, //应该是6
                i: 'produce_data'
              },
              {
                x: 18,
                y: 12,
                w: 6,
                h: 6, //应该是6
                i: 'output_sort'
              },
              {
                x: 18,
                y: 18,
                w: 6,
                h: 6, //应该是6
                i: 'flow_sort'
              }
            ]
          };
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
    },
    addTemplate() {
      if (this.templateName == '') {
        this.utils.errorMessage(this.$t('qingshurumobanmingcheng'));
        return;
      }

      this.monitorSetting.MONITOR_COCKPIT_TEMPLATES[this.dayjs().unix() + '||||' + this.templateName] = this.monitorSetting.MONITOR_COCKPIT_TEMPLATES['moren'];
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));

      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }

      this.addTemplateVisible = false;
    },
    removeTemplate() {
      delete this.monitorSetting.MONITOR_COCKPIT_TEMPLATES[this.monitorSetting.MONITOR_COCKPIT_TEMPLATE];
      this.monitorSetting.MONITOR_COCKPIT_TEMPLATE = 'moren';
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit('SetLayoutCockpit');
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
    },
    toEidtTemplate() {
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit('SetLayoutCockpit');
      this.utils.event_hub.$emit('BeginEditCockpit');
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 500);
    },
    save() {
      localStorage.setItem('MONITOR_SETTING', JSON.stringify(this.monitorSetting));
      this.utils.event_hub.$emit('SetLayoutCockpit');
    }
  }
};
</script>
